module.exports = __webpack_public_path__ + "media/greenhouse-hd04.26ca4b35.mp4";